import logo from "./images/yandex-logo.png"

export const YandexLoginButton = () => {

    const handleLogin = async () => {
        console.log("Войти через Yandex")
    }

    return (
        <button
            onClick={handleLogin}
            style={{
                marginTop: "1rem",
                display: "flex",
                alignItems: "center",
                gap: "10px",
                padding: "10px 20px",
                backgroundColor: "#fff",
                border: "1px solid #ccc",
                borderRadius: "8px",
                cursor: "pointer",
                fontSize: "26px",
                fontWeight: "500",
                boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
                width: "100%"
            }} disabled={true}>
            <img src={logo} alt="Yandex" width="30" height="30" />
            {'Yandex'}
        </button>
    )
}
